var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 2 15 11",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.664 11.092a1.88 1.88 0 01-1.325 1.322c-1.161.316-5.836.316-5.836.316s-4.676 0-5.837-.316A1.88 1.88 0 01.34 11.092C-.157 9.115-.02 5.977.33 3.918a1.88 1.88 0 011.325-1.322c1.162-.316 5.837-.326 5.837-.326s4.675 0 5.837.316a1.88 1.88 0 011.324 1.322c.495 1.986.38 5.122.01 7.184zm-8.659-1.35L9.883 7.5 6.005 5.26v4.48z"
  })));
};
export default SvgYoutube;